import React, { FC } from "react";
import "./WelcomeContent.scss";
import { Link, useNavigate } from "react-router-dom";
import ScrollToTop from "../UI/ScrollToTop";
import { NON_AUTH_ROUTE } from "../../pages/App/routes";
import CustomButton from "../UI/Buttons/CustomButton";
import LeftArrow from "../UI/Icons/LeftArrow";

/**
 * Welcome Content Props Interface
 * @interface WeclomeContentProps
 */
interface WelcomeContentProps {
  screenSize?: boolean;
}

const WelcomeContent: FC<WelcomeContentProps> = ({ screenSize }) => {
  const navigate = useNavigate();

  const handleCreateEnquiry = () => {
    navigate(NON_AUTH_ROUTE.CREATE_ENQUIRY);
  };

  const handleLoginPage = () => {
    navigate(NON_AUTH_ROUTE.LOGIN);
  };

  return (
    <>
      <ScrollToTop />
      <div
        className={`welcome-bg w-100 min-vh-100 p-20px d-flex flex-column justify-content-between ${
          screenSize ? "max-w-550px" : ""
        }`}
      >
        <div className="p-60px position-relative h-100 min-h-245px">
          <div className="d-flex flex-column gap-60 justify-content-between max-w-400px h-100">
            {screenSize && (
              <div className="d-flex">
                <CustomButton
                  variant={"primary"}
                  type="button"
                  className="btn-theme bg-off-white text-black"
                  onClick={handleLoginPage}
                >
                  <LeftArrow /> Return to Login Page
                </CustomButton>
              </div>
            )}
            <div className="fs-40 fs-mobile-22 fw-400 text-white">
              Ready to experience the Connected Crew difference?
            </div>
            <div className="border border-black-medium p-10px radius-10px d-none d-lg-flex flex-column gap-10 w-300px">
              <div className="fs-18 fw-400 text-black-medium">
                Are you a centre owner interested in connecting with candidates?
              </div>
              <div
                onClick={handleCreateEnquiry}
                className="align-self-start btn-theme bg-teal-medium text-black-medium cursor-pointer"
              >
                Submit an Enquiry
              </div>
            </div>
          </div>
        </div>
        <div className="d-none d-lg-flex gap-10 align-items-center position-relative">
          <div className="fs-13 fw-400 text-white">
            &copy; {new Date().getFullYear()} Connected Crew
          </div>
          <div className="w-1px h-20px bg-white"></div>
          <Link
            to={NON_AUTH_ROUTE.PRIVACY_POLICY}
            className="fs-13 fw-400 text-white text-decoration-none"
          >
            Privacy Policy
          </Link>
          <div className="w-1px h-20px bg-white"></div>
          <Link to={NON_AUTH_ROUTE.TERMS_OF_SERVICE} className="fs-13 fw-400 text-white text-decoration-none">
            Terms of Service
          </Link>
        </div>
      </div>
    </>
  );
};

export default WelcomeContent;
